// Рут LoadingOverlay по умолчанию absolute (облегает positioned-родителя) —
// поднимаем до фуллскрин-фикса; белую подложку 0.8 рисует overlay-слой Mantine
// (overlayProps в BackdropLoader.tsx).
.jf-backdrop-loader {
    position: fixed;
    inset: 0;
    height: 100vh;
}
